import type {
  ClientPreferencesComponentInput,
  ComponentValueResponse,
  SaveComponentValueResponse,
} from "@repo/shared/types";
import { get, post } from "../_client";

const BASE = "/internal/flow-instances";

export function getFlowInstanceValue(instanceId: string) {
  return get<ComponentValueResponse>(
    `${BASE}/${instanceId}/client-preferences/flow-instance-value`,
  );
}

export function saveFlowInstanceValue(instanceId: string, input: ClientPreferencesComponentInput) {
  return post<SaveComponentValueResponse>(
    `${BASE}/${instanceId}/client-preferences/flow-instance-value`,
    input satisfies ClientPreferencesComponentInput,
  );
}
